import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { CURATED_BASE_API } from '../../config/reactConstants';

const BASE_URL = CURATED_BASE_API
export const curatedBaseApi = createApi({
    baseQuery: fetchBaseQuery({ baseUrl: BASE_URL }),
    endpoints: () => ({}),
    reducerPath: BASE_URL
})